import { render, staticRenderFns } from "./ShiftsSetting.vue?vue&type=template&id=2eee52f0&scoped=true&"
import script from "./ShiftsSetting.vue?vue&type=script&lang=js&"
export * from "./ShiftsSetting.vue?vue&type=script&lang=js&"
import style0 from "./ShiftsSetting.vue?vue&type=style&index=0&id=2eee52f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eee52f0",
  null
  
)

export default component.exports